import React from "react";
import "../assets/css/card.css";
// import { Link } from "react-router-dom";
import EnrollmentNotSucessful from "./EnrollmentNotSucessful";

const Card = (props) => {
  const {
    id,
    courseName,
    courseDescription,
    coursePrice,
    courseTime,
    courseImage,
    // slot,
  } = props.data;

  const [modal, setModal] = React.useState(false);
  const [enrollActive, setEnrollActive] = React.useState(false);

  const openModal = () => {
    setModal(true);
  };

  const closeModal = () => {
    setModal(false);
  };
  React.useEffect(() => {
    if (modal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modal]);
  return (
    <div className="card-container" id={id}>
      <div className="card-image">
        <img src={courseImage} alt="courses" />
        <div className="overflow"></div>
      </div>
      <div className="card-item">
        <div className="card-content">
          <h2>{courseName}</h2>
          <button className="btn" onClick={openModal}>
            Explore Course
          </button>
        </div>

        {modal && (
          <div
            className="modal"
            style={{ WebkitTransition: " 400ms all", transition: "400ms all" }}
          >
            <img src={courseImage} alt={courseName} />
            <div className="modal-content">
              <h2>{courseName}</h2>
              <p>{courseDescription}</p>
              <p>Price: N{coursePrice}</p>
              <p>Duration: {courseTime}</p>
              <div className="modal-btn">
                {/* <Link
                  to={`/enroll/${slot}}`}
                  style={{ textDecoration: "none " }}
                > */}
                <button
                  className="btn2 enroll-btn"
                  onClick={() => {
                    setEnrollActive(true);
                    setTimeout(() => {
                      setEnrollActive(false);
                    }, 9000);
                  }}
                >
                  Enroll now
                </button>
                {/* </Link> */}
                <button className="btn2" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
            {enrollActive ? <EnrollmentNotSucessful /> : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
